import React, {createContext, useState, useCallback, useEffect} from 'react';
import Error from "../components/Error";

const EnvCtx = createContext();

export const EnvCtxProvider = (props) => {
    const [error, setError] = useState("");
    const [cciaa, setCciaa] = useState({});
    const [existLingua, setExistLingua] = useState(false);
    const [coloreHeader, setColoreHeader] = useState('');
    const [backgroundColore, setBackgroundColore] = useState('');
    const [homeCamera, setHomeCamera] = useState('');
    const [logoCamera, setLogoCamera] = useState('');
    const [faviconCamera, setFaviconCamera] = useState('');
    const [existRiepilogoBAndC, setexistRiepilogoBAndC] = useState(false);

    const getEnv = useCallback(async () => {
        try {
            const response = await fetch(window.prmeLocationOrigin + '/cciaa/getparamsbycamera');
            if (!response.ok) {
                throw new Error("Errore nella chiamata!");
            }
            const data = await response.json();
            const paramsObj = data.risposta.reduce((acc, item) => {
                acc[item.chiave] = item.valore;
                return acc;
            }, {});

            setCciaa(paramsObj);

            if (paramsObj.colore_header) setColoreHeader(paramsObj.colore_header);
            if (paramsObj.background_colore) setBackgroundColore(paramsObj.background_colore);
            if (paramsObj.homeCamera) setHomeCamera(paramsObj.homeCamera);


            setexistRiepilogoBAndC(
                paramsObj.riepilogoBAndC !== undefined &&
                (paramsObj.riepilogoBAndC === true || paramsObj.riepilogoBAndC === "true")
            );

        } catch (error) {
            setError("Error fetching environment: " + error);
        }
    }, []);

    const getLogoCamera = async () => {
        try {
            const response = await fetch(window.prmeLocationOrigin + '/cciaa/getlogocamera');
            const base64Image = await response.text();

            if (base64Image && base64Image.trim() !== "") {
                setLogoCamera(`data:image/jpeg;base64,${base64Image}`);
            } else {
                setLogoCamera("");
            }
        } catch (error) {
            setError('Error fetching image: ' + error);
        }
    };


    const getFaviconCamera = async () => {
        try {
            const response = await fetch(window.prmeLocationOrigin + '/cciaa/getfaviconcamera');
            const contentType = response.headers.get("Content-Type") || "image/x-icon";
            const base64Image = await response.text();
            if (base64Image && base64Image.trim() !== "") {
                setFaviconCamera(`data:${contentType};base64,${base64Image}`);
            } else {
                setFaviconCamera("");
            }
        } catch (error) {
            setError('Error fetching favicon: ' + error);
        }
    };

    const getExistLingua = async () => {
        try {
            const response = await fetch(window.prmeLocationOrigin + '/cciaa/getexistlingua');
            if (!response.ok) {
                throw new Error('Errore nella chiamata!');
            }
            const existLingua = await response.json();
            setExistLingua(existLingua);
        } catch (error) {
            setError('Error fetching lingua: ' + error);
        }
    };

    useEffect(() => {
        getLogoCamera();
        getExistLingua();
        getFaviconCamera();
    }, []);

    return (
        <EnvCtx.Provider value={{
            getEnv,
            error,
            getLogoCamera,
            getFaviconCamera,
            getExistLingua,
            cciaa, setCciaa,
            coloreHeader, backgroundColore, homeCamera,
            logoCamera, faviconCamera,
            existLingua, setExistLingua,
            existRiepilogoBAndC
        }}>
            {props.children}
        </EnvCtx.Provider>
    );
};

export default EnvCtx;